/* P&P Search: full screen search with trending searches, best sellers and live results as you type.
   Replaces the look of the theme search popup only. Results come from Shopify's own search. */
(function () {
  var TRENDING = ['Large Square', 'Fiorella', 'Kardia', 'Clara', 'Diora', 'Stem Roses'];
  var FEATURED = { title: 'Iconic Arrangements', url: '/collections/best-sellers' };
  var el, input, idle, live, grid, head, all, feat, timer, ctrl, rot, loadedFeat = false, lastOpen = 0;

  if (!document.getElementById('ppRS-font')) {
    var l = document.createElement('link');
    l.id = 'ppRS-font'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;1,400&display=swap';
    document.head.appendChild(l);
  }

  function money(v) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    try { return new Intl.NumberFormat('en-CA', { style: 'currency', currency: cur, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n); } catch (e) { return '$' + n; }
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function card(p) {
    var a = document.createElement('a');
    a.className = 'ppS__card'; a.href = p.url;
    var ph = document.createElement('span'); ph.className = 'ppS__ph';
    if (p.img) { var im = document.createElement('img'); im.loading = 'lazy'; im.alt = p.title; im.src = sized(p.img, 600); ph.appendChild(im); }
    var t = document.createElement('span'); t.className = 'ppS__t'; t.textContent = p.title;
    var pr = document.createElement('span'); pr.className = 'ppS__p'; pr.textContent = p.price;
    a.appendChild(ph); a.appendChild(t); a.appendChild(pr);
    return a;
  }

  function build() {
    el = document.createElement('div');
    el.id = 'ppS'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-label', 'Search'); el.setAttribute('data-lenis-prevent', '');
    el.innerHTML =
      '<div class="ppS__inner">' +
      '<div class="ppS__top"><span></span><a class="ppS__logo" href="/" data-logo aria-label="Prairies and Petals home"></a><button type="button" class="ppS__x" data-x aria-label="Close search"></button></div>' +
      '<form class="ppS__form" action="/search" method="get" role="search">' +
      '<input type="hidden" name="type" value="product">' +
      '<input class="ppS__in" type="search" name="q" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" aria-label="Search">' +
      '<span class="ppS__ph1" aria-hidden="true"><span>Search for</span><span class="ppS__rot" data-rot></span></span>' +
      '<button type="button" class="ppS__clear" data-clear aria-label="Clear">Clear</button>' +
      '</form>' +
      '<div class="ppS__idle" data-idle>' +
      '<p class="ppS__h">Trending searches</p><div class="ppS__trend" data-trend></div>' +
      '<div class="ppS__fh"><p class="ppS__title">' + FEATURED.title + '</p><a class="ppS__more" href="' + FEATURED.url + '">View all</a></div>' +
      '<div class="ppS__grid" data-feat></div>' +
      '</div>' +
      '<div class="ppS__live" data-live hidden>' +
      '<p class="ppS__h" data-head></p><div class="ppS__grid" data-grid></div>' +
      '<a class="ppS__all" data-all href="/search">See all results</a>' +
      '</div>' +
      '</div>';
    document.body.appendChild(el);
    input = el.querySelector('.ppS__in');
    idle = el.querySelector('[data-idle]'); live = el.querySelector('[data-live]');
    grid = el.querySelector('[data-grid]'); head = el.querySelector('[data-head]');
    all = el.querySelector('[data-all]'); feat = el.querySelector('[data-feat]');
    var logo = document.querySelector('.mobile-header__logo img, .primary-logo img, .header__logo img');
    var lg = el.querySelector('[data-logo]');
    if (logo) { var li = document.createElement('img'); li.src = logo.currentSrc || logo.src; li.alt = 'Prairies & Petals'; lg.appendChild(li); }
    else lg.textContent = 'Prairies & Petals';
    rot = el.querySelector('[data-rot]');
    var ri = 0;
    rot.textContent = TRENDING[0];
    setInterval(function () {
      if (!el.classList.contains('is-open') || input.value) return;
      rot.classList.add('is-out');
      setTimeout(function () { ri = (ri + 1) % TRENDING.length; rot.textContent = TRENDING[ri]; rot.classList.remove('is-out'); }, 350);
    }, 2600);
    var tr = el.querySelector('[data-trend]');
    TRENDING.forEach(function (w) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = w;
      b.addEventListener('click', function () { input.value = w; run(); input.focus(); });
      tr.appendChild(b);
    });
    el.querySelector('[data-x]').addEventListener('click', close);
    el.querySelector('[data-clear]').addEventListener('click', function () { input.value = ''; run(); input.focus(); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    el.addEventListener('click', function (e) { if (e.target === el) close(); });
  }

  function loadFeatured() {
    if (loadedFeat) return; loadedFeat = true;
    fetch(FEATURED.url + '/products.json?limit=4').then(function (r) { return r.json(); }).then(function (d) {
      (d.products || []).slice(0, 4).forEach(function (p) {
        var v = (p.variants || [])[0] || {};
        var prices = (p.variants || []).map(function (x) { return parseFloat(x.price); });
        var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
        feat.appendChild(card({ url: '/products/' + p.handle, title: p.title, img: p.images && p.images[0] && p.images[0].src, price: (min !== max ? 'From ' : '') + money(isFinite(min) ? min : v.price) }));
      });
    }).catch(function () {});
  }

  function run() {
    var q = input.value.trim();
    el.classList.toggle('has-q', !!q);
    idle.hidden = !!q; live.hidden = !q;
    if (!q) return;
    head.textContent = 'Results for “' + q + '”';
    all.href = '/search?type=product&q=' + encodeURIComponent(q);
    if (ctrl) try { ctrl.abort(); } catch (e) {}
    ctrl = window.AbortController ? new AbortController() : null;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
      var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
      grid.innerHTML = '';
      if (!ps.length) {
        var n = document.createElement('p'); n.className = 'ppS__none';
        n.textContent = 'Nothing found for “' + q + '”. Try ' + TRENDING.slice(1, 4).join(', ') + '.';
        grid.appendChild(n); all.hidden = true; return;
      }
      all.hidden = false;
      ps.forEach(function (p) {
        var from = p.price_min && p.price_max && p.price_min !== p.price_max;
        grid.appendChild(card({ url: p.url, title: p.title, img: p.image || (p.featured_image && p.featured_image.url), price: (from ? 'From ' : '') + money(from ? p.price_min : p.price) }));
      });
    }).catch(function () {});
  }

  function open() {
    if (!el) build();
    loadFeatured();
    document.documentElement.classList.add('ppS-lock');
    el.classList.add('is-open');
    setTimeout(function () { try { input.focus(); } catch (e) {} }, 60);
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('ppS-lock');
  }

  function trigger(e) {
    var t = e.target && e.target.closest && e.target.closest('[data-show-search-trigger]');
    if (!t) return;
    if (e.type === 'keydown' && e.key !== 'Enter') return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (Date.now() - lastOpen < 600) return;
    lastOpen = Date.now();
    open();
  }
  /* iPhone Safari only sends taps to elements it considers tappable, so mark the search icons and listen for touch too */
  function markTriggers() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-show-search-trigger]'), function (t) {
      if (t.getAttribute('data-pps')) return;
      t.setAttribute('data-pps', '1'); t.setAttribute('role', 'button');
      t.style.cursor = 'pointer';
      t.addEventListener('click', function () {});
    });
  }
  markTriggers();
  document.addEventListener('DOMContentLoaded', markTriggers);
  window.addEventListener('load', markTriggers);
  window.addEventListener('click', trigger, true);
  window.addEventListener('touchend', trigger, { capture: true, passive: false });
  window.addEventListener('keydown', trigger, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el && el.classList.contains('is-open')) close(); });
})();
